import { render } from "./DashboardWelcomeBack.vue?vue&type=template&id=32e64ae3"
import script from "./DashboardWelcomeBack.vue?vue&type=script&lang=js"
export * from "./DashboardWelcomeBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__